<template>
	<div class="flex justify-center align-middle flex-grow">
		<div class="flex flex-col self-center -mt-16 w-full" v-if="checkLatestStoreVersion">
			<div class="flex justify-center">
				<img :src="qr_placeholder" alt="QR-Code" class="w-48 cursor-pointer mt-12 mb-4 pt-4" />
			</div>
			<div class="flex justify-center">
				<div v-if="isLoginError" class="text-red-700 font-bold w-80 justify-end">{{ isLoginError }}: {{ getErrorMessage }}</div>
			</div>
			<div class="flex justify-center">
				<div class="w-full">
					<BaseButton class="w-48" @click="openQRReader">{{ $t('scan_qr') }}</BaseButton>
				</div>
			</div>
		</div>
		<div v-else class="flex flex-col justify-center">
			<div>
				<div>
					{{ $t('please_download_latest_connect_assist_version') }}
				</div>
				<BaseButton class="w-48 mt-4" @click="redirectToAppStore()">{{ $t('update') }}</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
import AppsEmployee from '@/mixins/AppsEmployee';
import BaseButton from '@/components/forms/buttons/BaseButton';
import LoadingSpinner from '@/mixins/LoadingSpinner';

export default {
	name: 'AppsEmployeeStart',
	components: { BaseButton },
	mixins: [AppsEmployee, LoadingSpinner],
	data() {
		return {
			qr_placeholder: require('../../../assets/qr-placeholder.png'),
		};
	},
	computed: {
		checkLatestStoreVersion() {
			const url = window.location.href;
			if (url.includes('appVersion=')) {
				const appVersion = url.split('appVersion=')[1];
				return appVersion > 20250704;
			} else return true;
		},
		isLoginError() {
			return this.$store.getters.getAppsEmployeeLoginStatusCode;
		},
		getErrorMessage() {
			return this.createErrorMessage();
		},
	},
	methods: {
		redirectToAppStore() {
			if (/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) {
				window.location = 'https://apps.apple.com/de/app/connect-assist/id6745514578';
			} else {
				window.location = 'https://play.google.com/store/apps/details?id=com.imd_net.connect_assist&pli=1';
			}
		},
		openQRReader() {
			window.appcontainer.scanQRCode();
		},
		createErrorMessage() {
			let errorMessage = this.$t('login_error');

			switch (this.$store.getters.getAppsEmployeeLoginStatusCode) {
				case 901:
					errorMessage = this.$t('qr_code_invalid');
					break;
				case 902:
					errorMessage = this.$t('damage_case_not_found');
					break;
				case 903:
					errorMessage = this.$t('damage_case_closed');
					break;
				case 405:
					errorMessage = this.$t('company_account_locked');
					break;
				case 455:
					errorMessage = this.$t('error_contact_customer_consultant');
					break;
				default:
					errorMessage = this.$t('login_error');
					break;
			}
			return errorMessage;
		},
	},
	watch: {
		isAppsEmployeeLoggedIn() {
			if (this.isAppsEmployeeLoggedIn) {
				this.$router.push({ name: 'AppsEmployeeMain' });
			}
		},
	},
};
</script>

<style scoped></style>
